module.exports = __webpack_public_path__ + "img/s_logo.2603a406.png";